/* LC Header JS
   ============
   Behavior for sections/lc-header.liquid + snippets/lc-mobile-drawer.liquid:
     • Desktop dropdown toggle (click/keyboard) — CSS handles :hover / :focus-within;
       this makes the caret buttons work on touch + keyboard and closes on outside click / Esc.
     • Mobile drawer open/close (hamburger), body scroll lock, Esc closes.
     • Mobile accordion groups (Protein Powders, Learn).
   Loaded with `defer` from the header section. Init-guarded.
*/

(function () {
  'use strict';
  if (window.__lcHeaderInit) return;
  window.__lcHeaderInit = true;

  var CONFIG = {
    openClass: 'is-open',
    bodyLockClass: 'lc-menu-open',
    desktopMin: 750   /* px — matches the CSS breakpoint where the desktop nav shows (Batch 3: was 990) */
  };

  var header = document.querySelector('[data-lc-header]');
  if (!header) return;

  /* ---------- Desktop dropdowns ---------- */
  var dds = Array.prototype.slice.call(header.querySelectorAll('[data-lc-dd]'));

  function closeAllDd(except) {
    dds.forEach(function (dd) {
      if (dd === except) return;
      dd.classList.remove(CONFIG.openClass);
      var btn = dd.querySelector('[data-lc-dd-toggle]');
      if (btn) btn.setAttribute('aria-expanded', 'false');
    });
  }

  dds.forEach(function (dd) {
    var btn = dd.querySelector('[data-lc-dd-toggle]');
    if (!btn) return;
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var open = dd.classList.toggle(CONFIG.openClass);
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) closeAllDd(dd);
    });
    /* leaving via mouse: let CSS :hover handle it; leaving via keyboard: close when focus exits */
    dd.addEventListener('focusout', function (e) {
      if (!dd.contains(e.relatedTarget)) {
        dd.classList.remove(CONFIG.openClass);
        btn.setAttribute('aria-expanded', 'false');
      }
    });
  });

  document.addEventListener('click', function (e) {
    if (!header.contains(e.target)) closeAllDd(null);
  });

  /* ---------- Mobile drawer ---------- */
  var menuBtn = header.querySelector('[data-lc-menu-toggle]');
  var drawer  = document.querySelector('[data-lc-menu-drawer]');

  function setDrawer(open) {
    if (!drawer || !menuBtn) return;
    drawer.classList.toggle(CONFIG.openClass, open);
    drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
    menuBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    menuBtn.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
    header.classList.toggle(CONFIG.openClass, open);
    document.body.classList.toggle(CONFIG.bodyLockClass, open);
    document.body.style.overflow = open ? 'hidden' : '';
  }

  if (menuBtn && drawer) {
    menuBtn.addEventListener('click', function () {
      setDrawer(!drawer.classList.contains(CONFIG.openClass));
    });

    /* Accordions inside the drawer */
    Array.prototype.slice.call(drawer.querySelectorAll('[data-lc-acc]')).forEach(function (group) {
      var t = group.querySelector('[data-lc-acc-toggle]');
      if (!t) return;
      t.addEventListener('click', function () {
        var open = group.classList.toggle(CONFIG.openClass);
        t.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });

    /* Close drawer if viewport grows past the desktop breakpoint */
    var mq = window.matchMedia('(min-width: ' + CONFIG.desktopMin + 'px)');
    var onMq = function (ev) { if (ev.matches) setDrawer(false); };
    if (mq.addEventListener) mq.addEventListener('change', onMq); else mq.addListener(onMq);
  }

  /* ---------- Esc closes everything ---------- */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    closeAllDd(null);
    setDrawer(false);
  });
})();
